import React, { useState, useEffect } from 'react';
import Sidebar from './components/Sidebar';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Publications from './components/Publications';
import Music from './components/Music';
import DarkModeToggle from './components/DarkModeToggle';
import Skills from './components/Skills';
import Blog from './components/Blog';
import Article from './components/Article';
import Education from './components/Education';
import ScrollToTopButton from './components/ScrollToTopButton';
import LoadingGate from './components/LoadingGate';
import './App.css';
import articlesData from './Articles/ArticlesData';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
// import Translations from './components/Translations';
function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  useEffect(() => {
    // Simulate loading time
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  return (
    <Router>
      <div className={`App ${darkMode ? 'dark-mode' : ''}`}>
        <LoadingGate isLoading={isLoading} />
        <DarkModeToggle darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
        
        <Routes>
          {/* Only render the Blog and sidebar on the main page */}
          <Route
            path="/"
            element={
              <>
                <div className="container">
                  <Sidebar />
                  <main className="main-content">
                    <About />
                    <Skills />
                    <Education />
                    <Experience />
                    <Projects />
                    <Publications />
                    <Music />
                    {/* <Translations /> */}
                    <Blog articles={articlesData} />
                  </main>
                </div>
              </>
            }
          />
         
          {/* Render only the Article component on the article page */}
          <Route
            path="/Article/:id"
            element={
              <main className="article-page">
                <Article articles={articlesData} darkMode={darkMode} />
              </main>
            }
          />
        </Routes>
        
        <ScrollToTopButton />
      </div>
    </Router>
  );
}

export default App;